export const key2name = (key: string): string[] => key.split(".");
